import ArrivalWindowSelect from "@/components/form/arrival-window-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";

/** **Value is hours as a string** — `"0.5"` … `"8"`. */
export type ArrivalWindowFieldProps = PickerFieldProps<string>;

export const ArrivalWindowField = makePickerField<string>({
  name: "ArrivalWindowField",
  control: ArrivalWindowSelect,
  popout: true,
});
